import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { EmpLeaveDTO } from './emp-leaves.dto';


export class EmpLeavesResponse extends GlobalResponseObject{
    data?: EmpLeaveDTO[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: EmpLeaveDTO[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}